import type { FC } from "react";
import { Helmet } from "react-helmet-async";

import AppleTouchIcon114 from "@shared/assets/favicons/apple-touch-icon-114x114.png";
import AppleTouchIcon72 from "@shared/assets/favicons/apple-touch-icon-72x72.png";
import AppleTouchIcon from "@shared/assets/favicons/apple-touch-icon.png";

const SSRHeadContent: FC = () => {
  return (
    <Helmet>
      <meta charSet="utf-8"></meta>
      <meta name="robots" content="noarchive nocache"></meta>
      <meta httpEquiv="X-UA-Compatible" content="IE=edge"></meta>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=2, user-scalable=yes"
      ></meta>

      <link rel="shortcut icon" href={AppleTouchIcon} />
      <link rel="apple-touch-icon" href={AppleTouchIcon} />
      <link rel="apple-touch-icon" sizes="72x72" href={AppleTouchIcon72} />
      <link rel="apple-touch-icon" sizes="114x114" href={AppleTouchIcon114} />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" />
      <link
        href="https://fonts.googleapis.com/css2?family=Mulish:wght@400;500;600;700;800&display=swap"
        rel="stylesheet"
      />
    </Helmet>
  );
};

export { SSRHeadContent };
